import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import si from 'si';
import {Modal} from 'react-bootstrap';
import {TextField} from '../../FormFields/formFields';
import DateTimePicker from 'react-datetime';
import HostPortalActions from './HostPortalActions';
import FAIcon from 'faIcon';
import Icon from 'svgIcon';
import EInvitations from './EInvitationContainer';
import {ShareButtons} from 'react-share';
import AddressLoader from '../../Addresses/AddressLoader';

export default class MyPartiesTab extends React.Component {
	constructor(props) {
		super(props);
        this.isValidDay = this.isValidDay.bind(this);
		this.showInviteModal = this.showInviteModal.bind(this);
		this.showPreviewModal = this.showPreviewModal.bind(this);
        this.state = {
            showEditModal: false,
			showPreview: false,
			inviteModal: false,
            changedPartyTitle: this.props.selectedEventDetails.name,
            changedEndDate: moment(this.props.selectedEventDetails.endDate).format('L'),
			selectedInviteTemplate: this.props.selectedEventDetails.inviteTemplate
        };
	}

    componentWillMount() {
        moment.locale(window.jenkon.culture);
    }

	componentDidMount() {
		HostPortalActions.getEventTypes();
	}

    changeField(name, value) {
        var diff = {};
        diff[name] = value;
        this.setState(diff);
    }

    changeEndDate(endDate) {
        if (moment.isMoment(endDate)) {
            this.setState({
                changedEndDate: endDate.format('L')
            });
        }
    }

    checkEndDate(endDate) {
        if (!moment.isMoment(endDate)) {
            this.setState({
                changedEndDate: moment(this.props.selectedEventDetails.endDate).format('L')
            });
        }
    }

	createPreviewTemplate() {
		var replaces = this.props.selectedEventDetails.templateReplacements;
		HostPortalActions.getTemplateResource(`Template.${this.props.selectedEventDetails.inviteTemplate}.Body`,
			//intercept and modify the template text
			function(resources) {
				var resource = resources[0].value;
				//replace $substitutions based on available templateReplacements for selected event
				replaces.sort(function(a, b) {
					return b.item1.length - a.item1.length;
				});
				for (var i = 0, len = replaces.length; i < len; i++) {
					var replace = replaces[i];
					resource = resource.replace("$" + replace.item1, replace.item2);
				}
				resources[0].value = resource;
				return resources;
			});
	}

    renderAddress(address) {
		if (!address) return null;
		return `${address.line1} ${address.city}, ${address.stateProvince}`;
	}

    showEditModal(visible) {
        this.setState({
            showEditModal: visible
        });
    }

	showInviteModal(visible) {
		this.setState({
			inviteModal: visible
		});
	}

	showPreviewModal(visible) {
		this.createPreviewTemplate();
		this.setState({
			showPreview: visible,
		});
	}

    showCalendar() {
        this.refs.PartyDate.setState({open: true});
    }

    isValidDay(current) {
        let yesterday = moment().subtract(1, 'day');
        let lastDay = moment(this.props.selectedEventDetails.startDate).add(this.props.selectedEventDetails.maxEventDays, 'day');
        return current.isAfter(yesterday) && current.isSameOrBefore(lastDay) && current.isAfter(this.props.selectedEventDetails.startDate);
    }

    setPartyVisibility(isPublic) {
		if (this.props.selectedEventDetails.isPublic !== isPublic) {
        	HostPortalActions.setPartyVisibility(isPublic, this.props.selectedEventDetails.code);
		}
    }

    savePartyChanges() {
        let eventData = {
            EventCode: this.props.selectedEventDetails.code,
            Name: this.state.changedPartyTitle,
            EndDate: this.state.changedEndDate
        };
        HostPortalActions.savePartyDetailsChanges(eventData);
        this.showEditModal(false);
    }

	createTemplateThumbnail(thumbnailId, i) {
		return (<TemplateThumbnail templateId={thumbnailId} key={i} {...this.props} selectedInviteTemplate={this.state.selectedInviteTemplate} setSelectedTemplate={this.setSelectedTemplate.bind(this)} />);
	}

	setSelectedTemplate(id, visible) {
		this.setState({
			selectedInviteTemplate: id
		}, () => {
			this.showInviteModal(visible)
		})
	}

	clickEater(e) {
		e.preventDefault();
		return false;
	}

	setInviteStyle() {
		if (this.state.selectedInviteTemplate !== this.props.selectedEventDetails.inviteTemplate) {
			HostPortalActions.setNewInviteStyle(this.props.selectedEventDetails.code, this.state.selectedInviteTemplate);
			this.showInviteModal(false);
		}
	}

	render() {

        let validationRules = {
            PartyTitle: {
                required: true,
                maxLength: 100,
                requiredMessage: window.jenkon.resources["PWS.MyAccount.PartyTitleRequired"],
            }
        };
        let CalendarData = {
			Size: 14,
			Fill: "#333333",
			name: "calendar_check_o"
		};
		let checkData = {
			Size: 14,
			Fill: "#999",
			name: "check"
		};

        let dateDisplay = this.props.selectedEventDetails.isVirtual ?
            <div className="partyDetails-item"><strong>{window.jenkon.resources["PWS.MyAccount.PartyDetailsOpenDatesLabel"]}:</strong>&nbsp; {moment(this.props.selectedEventDetails.startDate).format('LL')} - {moment(this.props.selectedEventDetails.endDate).format('LL')} </div>
            : <div className="partyDetails-item"><strong>{window.jenkon.resources["PWS.MyAccount.PartyDetailsOpenDatesLabel"]}:</strong>&nbsp; {moment(this.props.selectedEventDetails.eventDate).format('LL')}</div>;
        let location = this.props.selectedEventDetails.address === null ? 'ONLINE' : <AddressLoader showLocation="true"ref="adrloader" countryCode={this.props.selectedEventDetails.address.country} initialValues={this.props.selectedEventDetails.address} showLocation={true} />
		let shareURL = window.jenkon.consultantRoot + "SocialSharing?code=" + this.props.selectedEventDetails.code;

		return (
			<div className="active clearfix animate-in">
				<div className="col-lg-8 clearfix">
				<div className="formSectionSubTitle">{window.jenkon.resources["PWS.MyAccount.PartyDetailsTitle"]}</div>
	                <div className="partyDetailsWrapper">
					<div className="partyDetails-item"><strong>{window.jenkon.resources["PWS.MyAccount.PartyDetailsPartyTypeLabel"]}:</strong>&nbsp; {this.props.selectedEventDetails.eventTypeDescription}</div>
	                <div className="partyDetails-item"><strong>{window.jenkon.resources["PWS.MyAccount.PartyDetailsSubjectLabel"]}:</strong>&nbsp; {this.props.selectedEventDetails.name}</div>
	                <div className="partyDetails-item"><strong>{window.jenkon.resources["PWS.MyAccount.PartyDetailsConsultantLabel"]}:</strong>&nbsp; {this.props.selectedEventDetails.consultantName}</div>
	                {dateDisplay}
	                <div className="partyDetails-item"><strong>{window.jenkon.resources["PWS.MyAccount.PartyDetailsLocationLabel"]}:</strong>&nbsp; {location}</div>
	                </div>
	                <div>
                    <button className={classnames("primaryBtn", "customButton", {"visuallyhidden": this.props.selectedEventDetails.eventStatus !== "Active" || !this.props.selectedEventDetails.isVirtual})} onClick={this.showEditModal.bind(this, true)}>{window.jenkon.resources["PWS.MyAccount.PartyDetailsEditButton"]}</button>
	                </div>
	                <div className="spacer12"></div>
					<VisibilityStatus {...this.props} setPartyVisibility={this.setPartyVisibility.bind(this)}/>
					<div className="spacer12"></div>
					<SocialIcons {...this.props} />
	                <Modal show={this.state.showEditModal} onHide={this.showEditModal.bind(this, false)}>
	                    <Modal.Header closeButton>
                      <Modal.Title>{window.jenkon.resources["PWS.MyAccount.PartyDetailsEditPartyDetailsLabel"]}</Modal.Title>
	                    </Modal.Header>
	                    <Modal.Body>
                    <div className="clearfix">
                        <div className="formSectionSubTitle">{window.jenkon.resources["PWS.MyAccount.PartyDetailsTitle"]}</div>
                        <TextField
        					ref="changedPartyTitle"
        					name="changedPartyTitle"
                            value={this.state.changedPartyTitle}
                            handleChange={this.changeField.bind(this)}
        					Rules={validationRules.PartyTitle}
                            maxLength = {100}
                            label={window.jenkon.resources["PWS.MyAccount.PartyTitlePlaceholder"]}
        					classes="form-control input-100 input-bordered clearable"
        				/>
                        <div className="input-group date input-50 required-field">
                            <DateTimePicker ref="PartyDate" locale={window.jenkon.culture} inputProps={{readOnly: true}} value={this.state.changedEndDate} onBlur={this.checkEndDate.bind(this)} onChange={this.changeEndDate.bind(this)} isValidDate={this.isValidDay} closeOnSelect={true} timeFormat={false} />
                            <span className="input-group-addon" onClick={() => this.showCalendar()} ><FAIcon iconData={CalendarData} inline={true} /></span>
                        </div>
                    </div>
	                    </Modal.Body>
                    <Modal.Footer>
                        <div className="required-field-legend"> = Required</div>
                        <button type="button" className="secondaryBtn medium customButton" onClick={this.showEditModal.bind(this, false)}>{window.jenkon.resources["PWS.MyAccount.PartyDetailsEditPartyCancelLabel"]}</button>&nbsp;&nbsp;
                        <button type="button" className="primaryBtn medium customButton" onClick={this.savePartyChanges.bind(this)}>{window.jenkon.resources["PWS.MyAccount.PartyDetailsEditPartySaveChangesLabel"]}</button>
                    </Modal.Footer>
	                </Modal>
				</div>
				<EInvitations {...this.props} showModal={this.showInviteModal} showPreview={this.showPreviewModal} />
				<Modal show={this.state.showPreview} bsSize="lg" onHide={this.showPreviewModal.bind(this, false)}>
					<Modal.Header closeButton>
						{window.jenkon.resources["PWS.MyAccount.InvitePreviewModal"]}
					</Modal.Header>
					<Modal.Body>
						<div onClick={this.clickEater.bind(this)} dangerouslySetInnerHTML={{__html: this.props.currentInvitePreview}}/>
					</Modal.Body>
					<Modal.Footer>
                        <button type="button" className="secondaryBtn medium customButton" onClick={this.showPreviewModal.bind(this, false)}>{window.jenkon.resources["PWS.MyAccount.PartyDetailsEditPartyCancelLabel"]}</button>
                    </Modal.Footer>
				</Modal>
				<div id="emailStylesGallery" className={classnames("clearfix", {"visuallyhidden": !this.state.inviteModal})} >
					<div className="emailStylesGallery-title clearfix">
						<div className="formSectionSubTitle">{window.jenkon.resources["PWS.MyAccount.InvitationGalleryLabel"]}</div>
						<div className="galleryOptions-wrapper clearfix">
							<div className="themeSelectorLabel-partyDetails">&nbsp;</div>
							<div className="themeSelector-partyDetails">&nbsp;</div>
						</div>
					</div>
					<div className="simpleHR" />
					<div className="spacer12" />
					<div className="emailGallery clearfix">
						{this.props.selectedEventDetails.inviteTemplates ? this.props.selectedEventDetails.inviteTemplates.map(this.createTemplateThumbnail.bind(this)) : 'No templates found'}
					</div>
					<div className="emailStylesGallery-title clearfix">
						<div className="galleryOptions-wrapper clearfix">
							<div className="themeSelectorLabel-partyDetails">&nbsp;</div>
							<div className="themeSelector-partyDetails">&nbsp;</div>
							<div className="doneBtn" onClick={this.setSelectedTemplate.bind(this, this.props.selectedEventDetails.inviteTemplate, false)}>{window.jenkon.resources["PWS.MyAccount.InvitationGalleryCancelButton"]} </div>
							<div className="doneBtn" onClick={this.setInviteStyle.bind(this)}>{window.jenkon.resources["PWS.MyAccount.InvitationGalleryDoneButton"]} <FAIcon iconData={checkData} inline={true} /></div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class TemplateThumbnail extends React.Component {
	constructor(props) {
		super(props);
	}



	render() {
		let template = this.props.selectedEventDetails.inviteTemplates.find(t => t.code === this.props.templateId.code);
		let templateImage = (template&&template.thumbnailToken!==null&&template.thumbnailToken!=="") ? `${window.jenkon.imageEndpoint}${template.thumbnailToken}` : ``;
		let isActive = this.props.templateId.code === this.props.selectedInviteTemplate;
		return (
		<div className={classnames("emailStyle-thumb", {"active": isActive})} onClick={this.props.setSelectedTemplate.bind(this, this.props.templateId.code, true)}>
			<img rel="image_src" src={templateImage} data-style-category="standard" alt={this.props.resources["PWS.MyAccount.InvitationStyle"]} />
		</div>
		);
	}
}

class SocialIcons extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		if(this.props.selectedEventDetails.eventStatus !== "Active") return null;
		let googleShareURL = window.jenkon.consultantRoot + "SocialSharing?code=" + this.props.selectedEventDetails.code;
		let shareURL = window.jenkon.consultantRoot + "Events?code=" + this.props.selectedEventDetails.code;
		return (
			<div>
				<div className="spacer12"></div>
				<div className="simpleHR" style={{width: '90%', maxWidth: '360px'}}></div>
				<div className="formSectionSubTitle">
					{this.props.resources["PWS.MyAccount.PartyDetailsSharePartyOnTitle"]}
				</div>
				<div className="social-icons clearfix">
					<ShareButtons.FacebookShareButton url={shareURL} title={this.props.selectedEventDetails.name} picture={window.jenkon.imageEndpoint + this.props.selectedEventDetails.inviteTemplate}>
						<Icon name="FaceBookCircle" size={32} inline={true} />
					</ShareButtons.FacebookShareButton>
					<ShareButtons.TwitterShareButton url={shareURL} title={this.props.selectedEventDetails.name}>
						<Icon name="TwitterCircle" size={32} inline={true} />
					</ShareButtons.TwitterShareButton>
					<ShareButtons.GooglePlusShareButton url={googleShareURL}>
						<Icon name="GooglePlusCircle" size={32} inline={true} />
					</ShareButtons.GooglePlusShareButton>
					<ShareButtons.PinterestShareButton url={shareURL} media={window.jenkon.imageEndpoint + this.props.selectedEventDetails.inviteTemplate}>
						<Icon name="PinterestCircle" size={32} inline={true} />
					</ShareButtons.PinterestShareButton>
				</div>
			</div>
		)
	}
}

class VisibilityStatus extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		let iconData = {
			name: 'question_circle',
			Size: 15,
		};
		if(this.props.selectedEventDetails.eventStatus !== "Active") return null;
		return(
			<div>
				<div className="spacer12"></div>
				<div className="simpleHR" style={{width: '90%', maxWidth: '360px'}}></div>
				<div className="visibleToPublic formSectionSubTitle">{window.jenkon.resources["PWS.MyAccount.PartyDetailsPublicTitle"]}&nbsp;&nbsp;
				<FAIcon iconData={iconData} inline={true} tooltipDirection="right" tooltip={window.jenkon.resources["PWS.MyAccount.PartyDetailsPublicTooltipMessage"]}/>
				</div>
				<div>
					<input id="showonsiteyes" name="showonsite" type="radio" onChange={this.props.setPartyVisibility.bind(this, true)} defaultValue="show" checked={this.props.selectedEventDetails.isPublic} /> {window.jenkon.resources["PWS.MyAccount.PartyDetailsPublicYes"]} &nbsp;&nbsp;
					<input id="showonsiteno" name="showonsite" type="radio" defaultValue="noshow" onChange={this.props.setPartyVisibility.bind(this, false)} checked={!this.props.selectedEventDetails.isPublic} /> {window.jenkon.resources["PWS.MyAccount.PartyDetailsPublicNo"]}
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/Tab_MyParties.js